import { useCallback, useEffect } from "react";
import {
  Websockets$SendMessageType,
  Websockets$UserNotification,
  Websockets$UserNotificationType,
} from "@/custolink-transpiled_by_server/websocket_defs";
import { Client } from "@stomp/stompjs";

// @ts-expect-error no ts types for this
import SockJS from "sockjs-client/dist/sockjs";

import { uiNavigationState } from "@/custolink-state/ui_navigation_state";
import { useAtom } from "jotai";
import { serviceWorkerRegistration } from "@/load_service_worker";

export function useWebsocketsForAdminArea() {
  const [, setUiNavState] = useAtom(uiNavigationState);

  /**
   * !!!
   *
   * This must be in sync with the types in sw.js
   */
  const resolveUserNotifications = useCallback(
    (noti: Websockets$UserNotification) => {
      switch (noti.type) {
        case Websockets$UserNotificationType.EnduserRequestsAssetVideoCall:
          serviceWorkerRegistration?.active?.postMessage({
            type: "enduser-requests-video-call",
          });
          setUiNavState((existing) => ({
            ...existing,
            incomingVideoChatPollNow: true,
          }));
          break;
        case Websockets$UserNotificationType.EnduserMadeInquiryOnAsset:
          serviceWorkerRegistration?.active?.postMessage({
            type: "enduser-made-inquiry-on-asset",
          });
          break;
        case Websockets$UserNotificationType.EnduserRegisteredProductOnAsset:
          serviceWorkerRegistration?.active?.postMessage({
            type: "enduser-registered-product-on-asset",
          });
          break;
        case Websockets$UserNotificationType.EnduserStartedAssetAiConversation:
          serviceWorkerRegistration?.active?.postMessage({
            type: "enduser-started-asset-ai-conversation",
          });
          break;
      }
    },
    [],
  );

  useEffect(() => {
    const sock = new SockJS("/ws?__auth_context=admin_area");
    const client = new Client({
      webSocketFactory: () => sock,
      onConnect: () => {
        console.log("✅ WS Connected");
        client.subscribe("/user/queue/private", (message) => {
          // see SendWsMsgUsecase.kt for this:
          const body = JSON.parse(message.body) as {
            type: Websockets$SendMessageType;
            payloadOfType: unknown;
          };
          if (body.type == Websockets$SendMessageType.UserNotification) {
            resolveUserNotifications(
              body.payloadOfType as Websockets$UserNotification,
            );
          }
        });
      },
    });
    client.activate();
    return () => {
      client.deactivate();
    };
  }, []);

  return {};
}
